import React, { ButtonHTMLAttributes, forwardRef } from 'react';
import classNames from 'classnames';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  as?: React.ElementType;
  variant?:
    | 'primary'
    | 'secondary'
    | 'accent-cool'
    | 'accent-warm'
    | 'base'
    | 'outline'
    | 'outline-inverse'
    | 'unstyled';
  size?: 'big';
  href?: string;
}

/**
 * Button component
 *
 * Usage:
 * ```
 * <Button disabled variant="primary">Button text</Button >
 * ```
 */
const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, className, as: Component = 'button', variant, size, ...rest }, ref) => (
    <Component
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      ref={ref}
      className={classNames(
        'usa-button',
        {
          [`usa-button--${variant || ''}`]: variant && variant !== 'outline-inverse',
          'usa-button--outline usa-button--inverse': variant === 'outline-inverse',
          'usa-button--big': size === 'big',
        },
        className,
      )}
    >
      {children}
    </Component>
  ),
);

export default Button;
